import { useMemo, useState } from 'react';
import { modalContext } from "../contexts/modalContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function ModalProvider({
  children
}) {
  const [actions, setActions] = useState([]);
  const value = useMemo(() => ({
    inModal: true,
    actions,
    setActions
  }), [actions]);
  return /*#__PURE__*/_jsx(modalContext.Provider, {
    value: value,
    children: children
  });
}